module.exports = __webpack_public_path__ + "static/media/elements_header_background.873e5f45.png";